import React, { FC } from 'react';
import SvgIcon from './SvgIcon';

const ChevronDownIcon: FC = () => {
    return (
        <SvgIcon viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.6562 7.5L10.6563 12.5L5.65625 7.5"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

export default ChevronDownIcon;
